<div>
    <h5 [style.fontSize]="titleSize">{{title}}</h5>
    <div class="input_container">
        <input 
            [width]="width"
            [value]="value"
            [style.width]="width" 
            [type]="inputType"
            [disabled]="disabled"
            (input)="onInputChange($event.target.value)"
        />
        <div [style.background-color]="color" *ngIf="hasInfo" class="info">
            <span>{{info}}</span>
        </div>
    </div>
</div>